export const CvvID = 'credit-card-cvv';
const MonthID = 'credit-card-month';
export const NameID = 'credit-card-name';
export const NumberID = 'credit-card-number';
const YearID = 'credit-card-year';
const ZipID = 'credit-card-zip';

const IFRAME_STYLES = {
  base: [
    'font-family: Poppins, sans-serif',
    'background: #fafafa',
    'border: 1px solid #eeeeee',
    'border-radius: 8px',
    'color: #222222',
    'box-sizing: border-box',
    'position: relative',
    'display: inline-block',
    'width: 100%',
    'min-width: 0',
    'background-image: none',
    'padding: 10px 12px',
    'font-size: 14px',
    'font-weight: 500',
    'min-height: 45px',
    'height: 45px',
    'outline: none',
  ].join(';'),
  // #d04b6e is cerise.7
  error: ['border: 1px solid #d04b6e', 'color: #d04b6e !important'].join(';'),
  // 868e96 is gray.6
  placeholder: ['color: #868e96'].join(';'),
};

export const iFrameConfig = {
  enableAutoComplete: true,
  returnAutoCompleteValues: true,
  enablePrettyFormat: true,
  enableValidateOnBlur: false,
  origin: window.location.origin,
  pci: true,
  placeholder: 'Card Number',
  cvv: true,
  cvvContainerID: CvvID,
  cvvPlaceholder: 'CVV',
  styles: {
    ...IFRAME_STYLES,
    cvv: { ...IFRAME_STYLES },
  },
};

export const tokenExUtils = { CvvID, MonthID, NameID, NumberID, YearID, ZipID };

export enum TokenExCardTranslations {
  masterCard = 'mastercard',
  americanExpress = 'amex',
  visa = 'visa',
  discover = 'discover',
  diners = 'diners',
  jcb = 'jcb',
  unionPay = 'unionpay',
  unknown = 'unknown',
}

export const getCardDate = (month: string, year: string) => {
  const monthPad = month.padStart(2, '0');
  const yearPad = year.slice(-2);
  return `${monthPad}/${yearPad}`;
};
